// eslint-disable-next-line import/prefer-default-export
export const UserTypes = {
  ADMIN: 'admin',
  USER: 'user'
};
